import focusElement from './focusElement';

const selectors = {
  boldOptions: '.bold_options',
  firstOptionWithError: '.bold_option_error select',
  optionElement: '.bold_option_element select',
  singleOption: '.bold_option',
};

const classes = {
  boldErrorMessage: 'bold_error_message',
};

const config = {
  childList: true,
  attributes: true,
  subtree: true,
};

const linkErrorToSelect = (error) => {
  const errorId = `bold-error-${Date.now()}`;
  
  // Add unique ID to bold error span
  error.setAttribute('id', errorId);
  const singleOptionWrapper = error.closest(selectors.singleOption);
  const optionElement = singleOptionWrapper.querySelector(selectors.optionElement);
  
  if (!optionElement) return;
  
  // Reference error message from input
  optionElement.setAttribute('aria-describedby', errorId);
};

const notifyErrors = (errors) => {
  const firstOptionWithError = document.querySelector(selectors.firstOptionWithError);

  // Add aria-describedby to input
  for (let i = 0; i < errors.length; i++) {
    linkErrorToSelect(errors[i]);
  }
  
  focusElement(firstOptionWithError);
};

const isBoldError = (node) => {
  const hasErrorClass = node.classList.contains(classes.boldErrorMessage);
  return hasErrorClass;
};

const getErrorNodes = (elements) => {
  let errorNodes = [];

  const elementArray = Array.from(elements);

  for (let i = 0; i < elementArray.length; i++) {
    if (isBoldError(elementArray[i])) {
      errorNodes.push(elementArray[i]);
    }
  }

  return errorNodes;
}

const callback = (mutationList, observer) => {
  mutationList.forEach((mutation) => {
    if (mutation.type === 'childList') {
      const errorNodes = getErrorNodes(mutation.addedNodes);

      if (errorNodes.length === 0) return;

      notifyErrors(errorNodes);
    }
  });
}

const handleProductOptionErrors = () => {
  // Listen for new Bold errors w/ mutation observer
  const boldOptions = document.querySelector(selectors.boldOptions);

  if (!boldOptions) return;

  const observer = new MutationObserver(callback);
  observer.observe(boldOptions, config);
};

handleProductOptionErrors();

export default handleProductOptionErrors;
